import { Observable, throwError, of } from 'rxjs';
import { retryWhen, delay, mergeMap } from 'rxjs/operators';

/**
 * custom retryWhen rxjs operator. Lets you use instead of retry(x) to add a custom delay to requests.
 * TODO: on use, the error response won't contain the httperror response, only the getErrorMessage string.
 * refactor me so I can create an orderly switch on status like in myaccount api-service
 */
const DEFAULT_MAX_RETRIES = 3;
const getErrorMessage = (maxRetry: number) => `Tried to load Resource over XHR for ${maxRetry} times without success. Giving up.`;

export function delayedRetry<T = any>(delayMs: number, maxRetry = DEFAULT_MAX_RETRIES) {
  let retries = maxRetry;

  return (src: Observable<any>) => src.pipe<T>(
    retryWhen((errors: Observable<any>) => errors.pipe(
      delay(delayMs),
      mergeMap(error => retries-- > 0 ? of(error) : throwError(() => new Error(getErrorMessage(maxRetry))))
    ))
  );
}
